<ng-container #panelHost></ng-container>

<div
  class="bubble-btn"
  [class.is-dragging]="isDragging()"
  [class.is-popping]="isPopping()"
  [class.is-snapping]="isSnapping()"
  [class.is-restoring]="isRestoring()"
  [style.left.px]="pos().x"
  [style.top.px]="pos().y"
  (mousedown)="onMouseDown($event)"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="isHovered.set(false)">

  @if (isHovered() && !isPanelOpen()) {
    <div class="hover-label" [class.label-right]="!isOnRightEdge()">
      Plan with AVA
    </div>
  }

  <div class="bubble-circle">
    <img src="assets/icons/ava-agent/sparkle.svg" alt="AVA" class="sparkle-icon">
  </div>
</div>
